import { motion, AnimatePresence } from "framer-motion";
import { X, Warning, Sparkle, Confetti, ArrowRight } from "@phosphor-icons/react";
import api from "@/lib/api";

const STYLE = {
  caution: { color: "#EF6A56", bg: "rgba(239,106,86,0.08)", border: "rgba(239,106,86,0.25)", icon: Warning },
  encourage: { color: "#8B7CF6", bg: "rgba(139,124,246,0.08)", border: "rgba(139,124,246,0.22)", icon: Sparkle },
  celebrate: { color: "#16BC9C", bg: "rgba(22,188,156,0.10)", border: "rgba(22,188,156,0.25)", icon: Confetti },
};

export default function Nudges({ nudges = [], onAction, onChange }) {
  if (!nudges.length) return null;

  const dismiss = async (id) => {
    onChange?.(nudges.filter((n) => n.id !== id));
    try { await api.post("/nudges/dismiss", { nudge_id: id }); } catch {}
  };

  return (
    <div className="space-y-3 mb-6" data-testid="nudges">
      <div className="flex items-center gap-2">
        <span className="label-eyebrow">Coach — proactive guidance</span>
        <span className="w-1.5 h-1.5 rounded-full bg-sage typing-dot" />
      </div>
      <AnimatePresence initial={false}>
        {nudges.map((n) => {
          const s = STYLE[n.type] || STYLE.encourage;
          const Icon = s.icon;
          return (
            <motion.div
              key={n.id}
              layout
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, x: 24, transition: { duration: 0.2 } }}
              data-testid={`nudge-${n.id}`}
              className="clay p-5 flex items-start gap-4"
              style={{ background: s.bg, borderColor: s.border }}
            >
              <div className="w-10 h-10 rounded-2xl flex items-center justify-center shrink-0" style={{ background: "var(--surface)" }}>
                <Icon size={20} weight="fill" color={s.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-[15px]" style={{ color: s.color }}>{n.title}</p>
                <p className="text-sm text-ink/80 mt-1 leading-relaxed">{n.message}</p>
                {n.action && (
                  <button
                    data-testid={`nudge-action-${n.id}`}
                    onClick={() => onAction?.(n.action)}
                    className="group mt-3 inline-flex items-center gap-1.5 text-sm font-medium hover:gap-2.5 transition-all"
                    style={{ color: s.color }}
                  >
                    {n.action_label || "Open"}
                    <ArrowRight size={15} weight="bold" />
                  </button>
                )}
              </div>
              <button
                data-testid={`nudge-dismiss-${n.id}`}
                onClick={() => dismiss(n.id)}
                className="w-7 h-7 rounded-full hover:bg-surface/70 flex items-center justify-center shrink-0 transition-colors"
                title="Dismiss"
              >
                <X size={15} weight="bold" color="#7C8AA5" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
